module.exports = __webpack_public_path__ + "static/media/Marotte_Frene_Excelsior_MT4-09-Scale.4a59c061.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Frene_Excelsior_MT4-09-Scale.jpg
// module id = 954
// module chunks = 37